import { Link } from 'react-router-dom';

import { usePermissions } from '../../hooks/usePermissions';
import { READ_BOOKINGS_PERMISSIONS } from '../bookings/bookingPermissions';

/** Viewers who cannot open bookings, such as Finance, get plain text, not a dead link. */
export function GiftPassBookingLink({ id, reference }: { id: string; reference: string | null }) {
  const { hasAnyPermission } = usePermissions();
  if (!hasAnyPermission(...READ_BOOKINGS_PERMISSIONS)) {
    return <span className="nb-mono">{reference ?? 'Booking'}</span>;
  }
  return (
    <Link
      to={`/admin/bookings/${id}`}
      className="nb-mono"
      style={{ fontWeight: 700, color: 'var(--nb-primary-2)', textDecoration: 'underline' }}
    >
      {reference ?? 'View booking'}
    </Link>
  );
}
